import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { trackPageView } from '../lib/analytics'
import { whenTitleSettled } from '../lib/pageTitleBridge'

// Runs after the page's own effects (children first), so by the time it asks,
// the page has already said whether its title is still loading. Leaving a
// route before its title settles drops that page_view rather than reporting
// a "Loading…" page.
export function useAnalyticsPageViews() {
  const location = useLocation()
  useEffect(() => {
    const path = location.pathname + location.search
    return whenTitleSettled(() => trackPageView(path))
  }, [location.pathname, location.search])
}
